import { injectable, decorate, inject } from 'inversify';
import 'reflect-metadata';
import { SERVICE_IDENTIFIER } from 'constants/identifiers';

@injectable()
class CustomerService {
  constructor(apiService) {
    this.apiService = apiService;
  }

  async getCustomers(params) {
    const result = await this.apiService.get('/customers', params);
    return result;
  }
}

decorate(inject(SERVICE_IDENTIFIER.ApiService), CustomerService, 0);

export default CustomerService;
